import React, { useState, useRef } from "react";
import { FiEdit, FiTrash, FiPlus } from "react-icons/fi";
import { toast } from "react-toastify";
import { updateIndustry } from "../../services/userIndustry";
import Swal from 'sweetalert2';



const UpdateIndustry = ({ toggleModal, handleClose, selectedCustomer }) => {
    const canvasRef = useRef(null); // Reference to canvas element
    //industry 
    const [name, setIndustryName] = useState(selectedCustomer.name || "");
    const [subIndustry, setSubIndustryName] = useState();
    const [subIndustries, setSubIndusties] = useState((selectedCustomer.subIndustries) || []);
    //arabic
    const [industryArabicName, setIndustryArabicName] = useState(selectedCustomer.industryArabicName || "");
    const [arabicsubIndustryName, setArabicsubIndustryName] = useState(selectedCustomer.arabicsubIndustryName || "");
    const [arabicSubIndustries, setArabicSubIndustries] = useState((selectedCustomer.arabicSubIndustries) || []);
    const handleAddSubIndustry = () => {
        setSubIndusties([...subIndustries, subIndustry]);
        setSubIndustryName('')
        setArabicSubIndustries([...arabicSubIndustries, arabicsubIndustryName]);
        setArabicsubIndustryName('')
    };

    const combinedSubIndustries = subIndustries.map((englishName, index) => ({
        englishName,
        arabicName: arabicSubIndustries[index] || '',
    }));

    const handleRemoveSubIndustry = (subIndustryToRemove, arabicSubIndustryToRemove) => {
        Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to undo this action!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, remove it!"
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    // Remove the step
                    setSubIndusties(subIndustries.filter((subIndustry) => subIndustry !== subIndustryToRemove));
                    setArabicSubIndustries(arabicSubIndustries.filter((arabicSubIndustry) => arabicSubIndustry !== arabicSubIndustryToRemove));

                    // Show success message
                    Swal.fire({
                        title: "Removed!",
                        text: "The Industry has been successfully removed.",
                        icon: "success"
                    });
                } catch (error) {
                    // Show error message
                    Swal.fire({
                        title: "Error!",
                        text: "An unexpected error occurred. Please try again later.",
                        icon: "error"
                    });
                    console.error("Error removing Industry:", error);
                }
            }
        });
    };
    const handleSubmit = () => {
        if (!name) {
            return toast.info("industry Name is required")
        }

        if (!industryArabicName) {
            return toast.info(" Arabic industry  Name is required")
        }

        let updatedSubIndustries = [...subIndustries];
        if (subIndustry) {

            updatedSubIndustries.push(subIndustry);
        }
        let updatedArabicSubIndustries = [...subIndustries];
        if (arabicsubIndustryName) {

            updatedArabicSubIndustries.push(arabicsubIndustryName);
        }
        const industryData = {
            name,
            industryArabicName,
            subIndustries: updatedSubIndustries,
            arabicSubIndustries: updatedArabicSubIndustries

        }
        updateIndustry(selectedCustomer.id, industryData)
            .then((data) => {
                toast.success("Industry updated successfully");
                handleClose();
            })
            .catch((error) => {
                toast.error("Failed to update Industry");
                console.error("Failed to update Industry:", error);
                toggleModal();
            });
        // console.log(JSON.stringify(journeyData, null, 2));
    };

    return (
        <div className="fixed inset-0 bg-gray-500 bg-opacity-50 flex justify-center items-center z-50">
            <div className="bg-white rounded-lg p-6 w-1/2 max-h-[80vh] overflow-y-auto shadow-lg">
                <div className="flex justify-between">
                    <h2 className="text-2xl font-semibold mb-4">Update Industry</h2>
                    <h2
                        className="text-2xl font-semibold mb-4 cursor-pointer"
                        onClick={() => handleClose()}
                    >
                        X
                    </h2>
                </div>
                <form onSubmit={(e) => e.preventDefault()}>
                    {/* Industry Name*/}
                    <div className="grid grid-cols-2 gap-4 mb-4">
                        <div>
                            <label className="block text-gray-700 mb-1">Name </label>
                            <input type="text" value={name} onChange={(e) => setIndustryName(e.target.value)} placeholder="Enter name" className="w-full px-3 py-2 border rounded-md" />
                        </div>
                        <div dir="rtl">
                            <label className="block text-gray-700 mb-1">الاسم</label>
                            <input type="text" value={industryArabicName} onChange={(e) => setIndustryArabicName(e.target.value)} placeholder="أدخل الاسم" className="w-full px-3 py-2 border rounded-md" />
                        </div>
                    </div>

                    {/* Industry Name & Description */}
                    <div className="grid grid-cols-2 gap-4 mb-4">
                        <div>
                            <label className="block text-gray-700 mb-1">SubIndustry </label>
                            <input type="text" value={subIndustry} onChange={(e) => setSubIndustryName(e.target.value)} placeholder="Enter step name" className="w-full px-3 py-2 border rounded-md" />
                        </div>
                        <div dir="rtl">
                            <label className="block text-gray-700 mb-1">الصناعة الفرعية </label>
                            <input type="text" value={arabicsubIndustryName} onChange={(e) => setArabicsubIndustryName(e.target.value)} placeholder="أدخل اسم المرحلة" className="w-full px-3 py-2 border rounded-md" />
                        </div>
                    </div>

                    <div className="flex justify-end mb-6">
                        <button
                            onClick={() => {
                                handleAddSubIndustry();
                            }}
                            className="w-[40px] h-[40px] bg-green-500 text-white mt-5 py-2 rounded-[20px] flex justify-center items-center"
                        >

                            <FiPlus size={20} />
                        </button>
                    </div>

                    {/* Display subIndustries */}
                    <div className="grid grid-cols-2 gap-4 mb-6">
                        <div className="col-span-2">
                            <div className="grid grid-cols-3 gap-4">
                                <label className="text-left text-lg font-semibold">SubIndustries</label>
                                <div></div> {/* Empty center cell */}
                                <label className="text-right text-lg font-semibold">الصناعات الفرعية</label>
                            </div>
                            <div className="mt-4">
                                {combinedSubIndustries.map(({ englishName, arabicName }, index) => (
                                    <div key={index} className="mb-4 border-b pb-4">
                                        <div className="grid grid-cols-3 gap-4 items-center">
                                            <span className="text-gray-700 text-left">{englishName}</span>

                                            <div className="flex justify-center space-x-2">
                                                <button
                                                    type="button"
                                                    onClick={() => handleRemoveSubIndustry(englishName, arabicName)}
                                                    className="text-white bg-red-600 p-2 rounded-md"
                                                >
                                                    <FiTrash size={20} />
                                                </button>
                                            </div>

                                            <span className="text-gray-700 text-right">{arabicName}</span>
                                        </div>
                                    </div>
                                ))}
                            </div>

                        </div>
                    </div>
                </form>
                <button
                    onClick={handleSubmit}
                    className="w-full bg-blue-500 text-white px-4 py-2 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                >
                    Save Changes
                </button>
            </div>
        </div>
    );
};

export default UpdateIndustry;
